import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";

import Footer from "./components/Footer";
import Home from "./components/Home";
import Contact from "./components/Contact";
import Company from "./components/Company";
import Single from "./components/Single";
import Services from "./components/Services";
import Post from "./components/Post";
import Products from "./components/Products";
import CaseStudies from "./components/CaseStudies";

import logo from "./assets/logo.svg";
import { NavBar } from "ggmm-react-lib";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ReactGA from "react-ga";
import createHistory from "history/createBrowserHistory";
import axios from "axios";
import _ from "lodash";

//Google Analytics//
const history = createHistory();

class App extends Component {
  constructor() {
    super();
    this.state = {
      siteInfo: "Demo site",
      header: [],
      isLoading: true
    };
  }

  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    // axios.get(SITE_URL + "/wp-json/acf/v3/sitewide").then(res => {
    //   this.setState({
    //     global: res.data[0].acf
    //   });
    // });

    //copy this to get data
    axios.get(SITE_URL + "/wp-json/menus/v1/menus/menu-1").then(res => {
      let navData = []; // set empty array
      // loop through data
      _.map(res.data.items, item => {
        //menu item name
        const name = item.post_title,
          link = item.url,
          set = {
            name: name, // name: 'About'
            link: link // link: /about
          };
        navData.push(set);
      });
      this.setState({
        nav: navData
      });
    });
  }

  handleLoad = () => {
    const { isLoading } = this.state;
    if (isLoading) {
      this.setState({
        isLoading: false
      });
    }
  };

  render() {
    const { isLoading } = this.state;
    return (
      <Router history={history}>
        <div>
          <link
            rel="stylesheet"
            href="https://pro.fontawesome.com/releases/v5.1.0/css/all.css"
            integrity="sha384-87DrmpqHRiY8hPLIr7ByqhPIywuSsjuQAfMXAE0sMUpY3BM7nXjf+mLIUSvhDArs"
            crossOrigin="anonymous"
          />
          <NavBar
            backgroundColor="white"
            type="left"
            logo={logo}
            customClass="main-nav"
            navColor="white"
            logoWidth="200px"
            iconColor="gray"
            padding="16px"
            nav={this.state.nav}
            // social={this.state.social}
          />
          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  timeout={300}
                  classNames="fade">
                  <Switch location={location}>
                    <Route
                      exact
                      path="/"
                      render={props => (
                        <Home
                          isLoading={isLoading}
                          handleLoad={this.handleLoad}
                          siteTitle={this.state.siteInfo}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/company"
                      render={props => (
                        <Company siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                    <Route
                      exact
                      path="/services"
                      render={props => (
                        <Services siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                    <Route
                      exact
                      path="/products"
                      render={props => (
                        <Products siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                    <Route
                      exact
                      path="/applications"
                      render={props => (
                        <CaseStudies
                          siteTitle={this.state.siteInfo}
                          {...props}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/case/:id"
                      render={props => (
                        <Post siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                    <Route
                      exact
                      path="/page/:id"
                      render={props => (
                        <Single siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                    <Route
                      exact
                      path="/contact"
                      render={props => (
                        <Contact siteTitle={this.state.siteInfo} {...props} />
                      )}
                    />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
          <Footer title={this.state.siteInfo} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js